import React from 'react';
import classes from './SectionTitle.module.css';
import Reveal from '../Reveal/Reveal';

/**
 * Header for the three content strips (Events, News, Gallery): the section
 * name on the left, an optional "See all" link on the right.
 */
function SectionTitle({ title, eyebrow, seeAll, onclick }) {
  return (
    <Reveal className={classes.sectionTitle} selector="[data-line]" stagger={0.07} y={22}>
      <div className={classes.titleCont}>
        <div className={classes.titleGroup} data-line>
          {eyebrow && (
            <span className={classes.eyebrow}>
              <span className={classes.rule} aria-hidden="true" />
              {eyebrow}
            </span>
          )}
          <h2 className={classes.title}>{title}</h2>
        </div>

        {seeAll && (
          <button type="button" className={classes.seeAll} onClick={onclick} data-line>
            <span>See all</span>
            <svg viewBox="0 0 16 16" aria-hidden="true">
              <path
                d="M3 8h9M8.5 4l4 4-4 4"
                fill="none"
                stroke="currentColor"
                strokeWidth="1.8"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </button>
        )}
      </div>
    </Reveal>
  );
}

export default SectionTitle
